import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import PrimaryButton from "../components/PrimaryButton";
import { Mic, Sparkles, Mail } from "lucide-react";

const screens = [
  { Icon: Mic, title: "Record your sessions", lines: ["Never lose what matters most.", "Press record and stay present."] },
  { Icon: Sparkles, title: "AI writes your notes", lines: ["Structured summaries in seconds.", "Clear, concise and clinical."] },
  { Icon: Mail, title: "Delivered to your inbox", lines: ["Always where you need them.", "Beautifully formatted, ready to share."] },
];

const Onboarding = () => {
  const [idx, setIdx] = useState(0);
  const nav = useNavigate();
  const { user, refresh } = useAuth();

  const finish = async () => {
    await api.post("/auth/complete-onboarding");
    await refresh();
    if (user?.role === "client" && !user?.linked_practitioner_id) {
      nav("/link-practitioner", { replace: true });
    } else {
      nav("/dashboard", { replace: true });
    }
  };

  const next = () => {
    if (idx < screens.length - 1) setIdx(idx + 1);
    else finish();
  };

  const { Icon, title, lines } = screens[idx];

  return (
    <div className="min-h-screen flex flex-col px-6 py-12 well-page-enter">
      <div className="flex justify-end">
        <button
          onClick={finish}
          className="text-sm font-medium text-[#4A5D52] underline underline-offset-4"
          data-testid="onboarding-skip-btn"
        >
          Skip
        </button>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center gap-12">
        <div className="w-32 h-32 rounded-full bg-white/50 backdrop-blur-xl border border-white/40 flex items-center justify-center shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
          <Icon size={56} strokeWidth={1.5} className="text-[#8BA38E]" />
        </div>
        <div className="text-center max-w-sm flex flex-col gap-3">
          <h2 className="text-3xl font-bold text-[#2A3B32]">{title}</h2>
          {lines.map((l, i) => (
            <p key={i} className="text-base text-[#4A5D52] leading-relaxed">{l}</p>
          ))}
        </div>
        <div className="flex gap-2">
          {screens.map((_, i) => (
            <span
              key={i}
              className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-[#8BA38E]" : "w-1.5 bg-[#8A9C91]/40"}`}
            />
          ))}
        </div>
      </div>
      <div className="w-full max-w-sm mx-auto pb-4">
        <PrimaryButton onClick={next} data-testid="onboarding-next-btn">
          {idx === screens.length - 1 ? "Get Started" : "Next"}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default Onboarding;
